import {
    CalendarDayIcon,
    CalendarListIcon,
    CalendarMonthIcon,
    CalendarWeekIcon,
    DownArrowIcon,
    EquipmentIcon,
    ShirtIcon,
    TableIcon,
} from "@xola/icons";
import { PopoverList } from "@xola/ui-kit";
import React, { useState } from "react";
import { Permission } from "types";
import { useAuthorization } from "../../../hooks/useAuthorization";
import { DashboardMode } from "../../../types/Dashboard";

const items = [
    {
        name: "List",
        key: DashboardMode.LIST,
        icon: CalendarListIcon,
    },
    {
        name: "Table",
        key: DashboardMode.TABLE,
        icon: TableIcon,
    },
    {
        name: "Day",
        key: DashboardMode.DAY,
        icon: CalendarDayIcon,
    },
    {
        name: "Week",
        key: DashboardMode.WEEK,
        icon: CalendarWeekIcon,
    },
    {
        name: "Month",
        key: DashboardMode.MONTH,
        icon: CalendarMonthIcon,
    },
    {
        name: "Equipment",
        key: DashboardMode.EQUIPMENT,
        icon: EquipmentIcon,
    },
    {
        name: "Merchandise",
        key: DashboardMode.MERCHANDISE,
        icon: ShirtIcon,
    },
];

interface DashboardModePickerProps {
    activeItem: DashboardMode;
    onChange: (mode: DashboardMode) => void;
}

export const DashboardModePicker = ({ activeItem = DashboardMode.LIST, onChange }: DashboardModePickerProps) => {
    const activeMode = items.find((item) => item.name === activeItem || item.key === activeItem);
    const activeItemText = activeMode ? activeMode.name : items[0].name;
    const [active, setActive] = useState(activeMode ? activeMode.key : items[0].key);
    const [visible, setVisible] = useState(false);

    const { isGranted } = useAuthorization();

    const hide = () => {
        setVisible(false);
    };

    const handleClick = () => {
        setVisible(!visible);
    };

    const handleChangeActive = (e: any, name: string) => {
        hide();
        const matchingItem = items.find((item) => item.name === name);

        if (matchingItem) {
            setActive(matchingItem.key);
            onChange(matchingItem.key);
        }
    };

    const ActiveIcon = activeMode?.icon;

    return (
        <div className="inline-block" data-testid="mode-view-type-dropdown-button">
            <PopoverList offset={[0, 18]} visible={visible} onClickOutside={hide}>
                <div className="flex cursor-pointer" onClick={handleClick}>
                    <div className="ml-2 border-b">
                        <ActiveIcon size="large" className="mb-1" /> {activeItemText}
                    </div>
                    <div>
                        <DownArrowIcon size="large" className="ml-1 text-gray-dark " />
                    </div>
                </div>
                {items.map((item) => {
                    if (item.name === "Equipment" && !isGranted(Permission.VIEW_RESOURCES_EQUIPMENT)) {
                        return;
                    }
                    if (item.name === "Merchandise" && !isGranted(Permission.MERCHANDISE_PURCHASE_VIEW)) {
                        return;
                    }

                    const Icon = item.icon;

                    return (
                        <PopoverList.Item
                            key={item.key}
                            name={item.name}
                            isActive={item.key === active}
                            onClickItem={handleChangeActive}
                        >
                            <Icon />
                            <span>{item.name}</span>
                        </PopoverList.Item>
                    );
                })}
            </PopoverList>
        </div>
    );
};
